var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "collapse-container shadow-sm rounded" },
    [
      _c(
        "div",
        {
          staticClass: "d-flex collapse-header",
          class: { pointer: !_vm.disabled },
          attrs: {
            "aria-controls": _vm.key,
            "aria-expanded": _vm.model ? "true" : "false"
          },
          on: { click: _vm.toggle }
        },
        [
          _c(
            "div",
            { staticClass: "row no-gutters align-items-center w-100" },
            [
              _c("div", { staticClass: "col-auto mr-2" }, [
                _c(
                  "div",
                  {
                    staticClass: "collapse-icon rounded-circle text-white",
                    style: {
                      backgroundColor: _vm.disabled ? "#3F5B60" : "#FF7058"
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "far",
                      class: {
                        "fa-chevron-down": _vm.model,
                        "fa-chevron-right": !_vm.model
                      }
                    })
                  ]
                )
              ]),
              _c("div", { staticClass: "font-weight-bold col" }, [
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ]),
              !_vm.disabled
                ? _c(
                    "div",
                    { staticClass: "col-auto ml-auto" },
                    [
                      _c("action-button", {
                        attrs: {
                          i: "far fa-times-circle",
                          variant: "border-0 bg-transparent p-0 text-danger"
                        },
                        on: { click: _vm.remove }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "col-12 mt-2" }, [
                _vm._v(" " + _vm._s(_vm.description) + " ")
              ])
            ]
          )
        ]
      ),
      _c(
        "b-collapse",
        { staticClass: "my-3", attrs: { id: _vm.key, visible: _vm.model } },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }